module.exports = __webpack_public_path__ + "img/product_types.a056b7c8.png";